import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-7933a5a4"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "footer-pc"
};
const _hoisted_2 = {
  class: "container"
};

const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"left container-item\" data-v-7933a5a4><div class=\"title\" data-v-7933a5a4>共熵服务中心</div><div class=\"content\" data-v-7933a5a4> 地址：深圳市福田区桃花路14号深港国际科技园B座5楼 </div></div><div class=\"center container-item\" data-v-7933a5a4><div class=\"title\" data-v-7933a5a4>联系我们</div><div class=\"content\" data-v-7933a5a4> 机构合作：contact@comentropy.org <br data-v-7933a5a4>媒体合作：media@comentropy.org <br data-v-7933a5a4><a href=\"https://beian.miit.gov.cn/\" target=\"_blank\" data-v-7933a5a4>粤ICP备2023142229号</a></div></div>", 2);

const _hoisted_5 = {
  class: "right container-item"
};

const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "title"
}, "关注我们", -1));

const _hoisted_7 = {
  class: "content"
};
import SocialIconPc from './social-icon-pc.vue';
export default {
  __name: 'footer-pc',

  setup(__props) {
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_5, [_hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(SocialIconPc)])])])]);
    };
  }

};